'use client'

import React, { useState, useEffect } from 'react'
import { useRouter } from 'next/navigation'
import styles from './styles.module.css'

const Portfolio: React.FC = () => {
  const [windowWidth, setWindowWidth] = useState(1440)
  const router = useRouter()

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }

    handleResize() // Set initial width
    window.addEventListener('resize', handleResize)
    
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  // Calculate card width based on screen size
  const getCardSize = () => {
    if (windowWidth <= 1439) {
      // Mobile and Tablet: 20.5rem (328px) x 24.625rem (394px)
      return { width: 20.5, height: 24.625 }
    }
    // Desktop: 21.875rem (350px) x 26.25rem (420px)
    return { width: 21.875, height: 26.25 }
  }

  const cardSize = getCardSize()

  // Функция для обработки клика по карточке
  const handleCaseClick = (caseId: number) => {
    const caseRoutes: Record<number, string> = {
      1: '/portfolio/treasury-automation',
      2: '/portfolio/materials-marketplace', 
      3: '/portfolio/multibanking'
    }
    
    const route = caseRoutes[caseId]
    if (route) {
      router.push(route)
    }
  }

  const cases = [
    {
      id: 1,
      title: 'Автоматизация казначейства в финансовом секторе',
      description: 'Автоматизация процессов обработки трансграничных платежей',
      category: 'Финансы',
      image: '/images/portfolio/redesign/case_card_image_1.png'
    },
    {
      id: 2,
      title: 'Онлайн маркетплейс материалов',
      description: 'Платформа, объединяющая заказчиков и производителей материалов со всего мира',
      category: 'Ритейл',
      image: '/images/portfolio/redesign/case_card_image_2.png'
    },
    {
      id: 3,
      title: 'Мультибанкинг: автоматизация в финтехе',
      description: 'Сервис для автоматического распознавания банковских выписок',
      category: 'Финансы',
      image: '/images/portfolio/redesign/case_card_image_3.png'
    }
  ]

  return (
    <section className={styles.portfolio}>
      <div className={styles.container}>
        {/* Block heading */}
        <div className={styles.heading}>
          <div className={styles.subtitle}>
            <p className={styles.subtitleText}>
              Кейсы
            </p>
          </div>
          <div className={styles.title}>
            <h2 className={styles.titleText}>
              Реализованные проекты
            </h2>
          </div>
        </div>
        
        {/* Case cards */}
        <div className={styles.grid}>
          {cases.map((caseItem) => (
            <div 
              key={caseItem.id} 
              className={styles.card}
              style={{
                width: `${cardSize.width}rem`
              }}
            >
              {/* Case image */}
              <div 
                className={styles.imageContainer}
                style={{
                  width: `${cardSize.width}rem`,
                  height: `${cardSize.height}rem`,
                  cursor: 'pointer'
                }}
                onClick={() => handleCaseClick(caseItem.id)}
              >
                <div 
                  className={styles.imageBackground}
                  style={{
                    backgroundImage: caseItem.image ? `url('${caseItem.image}')` : undefined,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }}
                />
                {/* Category chevron */}
                <div className={styles.categoryBadge}>
                  <span className={styles.categoryText}>
                    {caseItem.category}
                  </span>
                </div>
              </div>
              
              {/* Case content */}
              <div 
                className={styles.content}
                style={{
                  width: `${cardSize.width}rem`
                }}
              >
                <div className={styles.textContainer}>
                  <div className={styles.titleContainer}>
                    <h3 
                      className={styles.cardTitle}
                      dangerouslySetInnerHTML={{ __html: caseItem.title }}
                    />
                  </div>
                  <div className={styles.descriptionContainer}>
                    <p 
                      className={styles.cardDescription}
                      dangerouslySetInnerHTML={{ __html: caseItem.description }}
                    />
                  </div>
                </div>
                
                <div className={styles.link}>
                  <div 
                    className={styles.linkContent}
                    onClick={() => handleCaseClick(caseItem.id)}
                  >
                    <span className={styles.linkText}>Подробнее</span>
                    <div className={styles.linkIcon}>
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M6.33333 3V4.33333H10.7267L3 12.06L3.94 13L11.6667 5.27333V9.66667H13V3H6.33333Z" fill="#f23b67" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {/* View all cases button */}
        <div className={styles.viewAllButton}>
          <button
            className={styles.viewAllButtonContent}
            onClick={() => router.push('/cases/')}
          >
            <span className={styles.viewAllButtonText}>Смотреть все кейсы</span>
            <div className={styles.viewAllButtonIcon}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6.33333 3V4.33333H10.7267L3 12.06L3.94 13L11.6667 5.27333V9.66667H13V3H6.33333Z" fill="white" />
              </svg>
            </div>
          </button>
        </div>
      </div>
    </section>
  )
}

Portfolio.displayName = 'Portfolio'

export default Portfolio
